import React, { useState, useEffect } from 'react';
import { Grid } from '@mui/material';
import useStyles from '../styles';
import { InputField } from '../../fields';
import { useFormikContext } from 'formik';
import WarningIcon from '@mui/icons-material/Warning';
import { theme } from '../../layout/MaterialLayout';

export default function Questions(props) {
  const classes = useStyles();
  const [errors, setErrors] = useState();
  const [questions, setQuestions] = useState();

  const {
    getField,
    formField: {
      fullname,
      company,
      email,
   
    } } = props;

  const fieldName = props.init && getField("Title");
  const fieldCompany = props.init && getField("Company");
  const fieldEmail = props.init && getField("BGEmail");
  const { values: formValues } = useFormikContext();
  const { errors: formErrors, touched: formTouched } = useFormikContext();
  const disclaimerText = props.init && props.init.formTexts.NewsLetterDisclaimer;

  useEffect(() => {
    getErrors()
  }, [formTouched]);

  const getErrors = () => {
    let count = 0;
    let question = '';
    if (formErrors.fullname) {
      count++;
      question += fieldName.description;
    }
    if (formErrors.company) {
      if (count > 0) {
        question += ', '
      }
      question += fieldCompany.description;
      count++;
    }
    if (formErrors.email) {
      if (count > 0) {
        question += ', '
      }
      question += fieldEmail.description;
      count++;
    }
    setErrors(count);
    setQuestions(question);
  }
  return (
    <div className={classes.questionsform} style={{padding:theme.spacing(4)}}>
      <Grid container spacing={3}>
        <Grid item size={{xs:12}}>
          <div><span className={classes.error}>*</span> <span style={{ color: '#0000008a' }}>Required</span></div>
        </Grid>

        <Grid item size={{xs:12}}>
          <InputField name={fullname.name} label={`${fullname.label} ${fieldName.description} *`} fullWidth variant="outlined" color="secondary" />
        </Grid>
        <Grid item size={{xs:12}}>
          <InputField name={company.name} label={`${company.label} ${fieldCompany.description} *`} fullWidth variant="outlined" color="secondary" />
        </Grid>
        <Grid item size={{xs:12}}>
          <InputField name={email.name} label={`${email.label} ${fieldEmail.description} *`} fullWidth variant="outlined" color="secondary" />
        </Grid>
        <Grid item size={{xs:12}}>
          {errors > 0 && <div className={classes.error}><WarningIcon style={{ verticalAlign: 'bottom' }} /> {errors} question{errors > 1 ? 's' : ''} need to be completed before submitting: {questions}</div>}
        </Grid>
        <Grid item size={{xs:12}}>
          <div dangerouslySetInnerHTML={{ __html: disclaimerText }}></div>
        </Grid> 
      </Grid>
    </div>
  )
}